import continentAfrica from '../topoJson/continents/africa.topo.json';
import continentAsia from '../topoJson/continents/asia.topo.json';
import continentEurope from '../topoJson/continents/europe.topo.json';
import continentNorthAmerica from '../topoJson/continents/north-america.topo.json';
import continentOceania from '../topoJson/continents/oceania.topo.json';
import continentSouthAmerica from '../topoJson/continents/south-america.topo.json';
import countryAustralia from '../topoJson/countries/australia.topo.json';
import countryBelgium from '../topoJson/countries/belgium.topo.json';
import countryCanada from '../topoJson/countries/canada.topo.json';
import countryColombia from '../topoJson/countries/colombia.topo.json';
import countryCroatia from '../topoJson/countries/croatia.topo.json';
import countryCzechia from '../topoJson/countries/czechia.topo.json';
import countryFrance from '../topoJson/countries/france.topo.json';
import countryGermany from '../topoJson/countries/germany.topo.json';
import countryItaly from '../topoJson/countries/italy.topo.json';
import countryJapan from '../topoJson/countries/japan.topo.json';
import countryMalaysia from '../topoJson/countries/malaysia.topo.json';
import countryMexico from '../topoJson/countries/mexico.topo.json';
import countryNetherlands from '../topoJson/countries/netherlands.topo.json';
import countryNewZealand from '../topoJson/countries/new-zealand.topo.json';
import countryPanama from '../topoJson/countries/panama.topo.json';
import countryPoland from '../topoJson/countries/poland.topo.json';
import countryPortugal from '../topoJson/countries/portugal.topo.json';
import countryRomania from '../topoJson/countries/romania.topo.json';
import countrySerbia from '../topoJson/countries/serbia.topo.json';
import countrySlovakia from '../topoJson/countries/slovakia.topo.json';
import countrySlovenia from '../topoJson/countries/slovenia.topo.json';
import countrySouthKorea from '../topoJson/countries/south-korea.topo.json';
import countrySpain from '../topoJson/countries/spain.topo.json';
import countryTurkey from '../topoJson/countries/turkey.topo.json';
import countryUkraine from '../topoJson/countries/ukraine.topo.json';
import countryUnitedKingdom from '../topoJson/countries/united-kingdom.topo.json';
import countryUnitedStatesVirginIslands from '../topoJson/countries/united-states-virgin-islands.topo.json';
import countryUnitedStates from '../topoJson/countries/united-states.topo.json';
import worldContinents from '../topoJson/world-continents.topo.json';

export const geographyStyle = (darkMode) => {
  return {
    default: {
      fill: darkMode ? '#6e7076' : '#cccbcb', // --map-surface-default
      stroke: darkMode ? '#414141' : '#f2f2f2', // --map-stroke
      strokeWidth: 1,
      outline: 'none',
    },
    hover: {
      fill: darkMode ? '#222222' : '#b2b2b2', // --map-surface-hover
      stroke: darkMode ? '#414141' : '#f2f2f2', // --map-stroke
      strokeWidth: 1,
      outline: 'none',
    },
    pressed: {
      fill: darkMode ? '#1aa8e0' : '#2b7e8e', // --map-surface-click
      stroke: darkMode ? '#414141' : '#f2f2f2', // --map-stroke
      strokeWidth: 1,
      outline: 'none',
    },
  };
};

export const mapConfig = {
  world: { geoUrl: worldContinents, center: [0, 45], scale: 140 },
  continents: {
    Africa: { geoUrl: continentAfrica, center: [5, 2], scale: 400 },
    Asia: { geoUrl: continentAsia, center: [100, 55], scale: 200 },
    Europe: { geoUrl: continentEurope, center: [17, 67], scale: 290 },
    Oceania: { geoUrl: continentOceania, center: [136, -26], scale: 600 },
    'South America': { geoUrl: continentSouthAmerica, center: [-75, -27], scale: 400 },
    'North America': { geoUrl: continentNorthAmerica, center: [-95, 65], scale: 200 },
  },
  countries: {
    Australia: { geoUrl: countryAustralia, center: [122, -28], scale: 800 },
    Belgium: { geoUrl: countryBelgium, center: [-7.5, 50.5], scale: 9800 },
    Canada: { geoUrl: countryCanada, center: [-110, 71], scale: 270 },
    Colombia: { geoUrl: countryColombia, center: [-80, 4], scale: 1800 },
    'Croatia (Hrvatska)': { geoUrl: countryCroatia, center: [5, 44.5], scale: 4700 },
    'Czech Republic': { geoUrl: countryCzechia, center: [3.5, 49.8], scale: 6500 },
    France: { geoUrl: countryFrance, center: [-9, 46.5], scale: 2200 },
    Germany: { geoUrl: countryGermany, center: [1, 50], scale: 2000 },
    Italy: { geoUrl: countryItaly, center: [5, 42], scale: 2200 },
    Japan: { geoUrl: countryJapan, center: [125, 38], scale: 1600 },
    Malaysia: { geoUrl: countryMalaysia, center: [97, 4], scale: 2500 },
    Mexico: { geoUrl: countryMexico, center: [-115, 24], scale: 1500 },
    Netherlands: { geoUrl: countryNetherlands, center: [-7, 52.2], scale: 6500 },
    'New Zealand': { geoUrl: countryNewZealand, center: [165, -41], scale: 1600 },
    Panama: { geoUrl: countryPanama, center: [-92, 8], scale: 8500 },
    Serbia: { geoUrl: countrySerbia, center: [9, 44.3], scale: 5500 },
    Slovenia: { geoUrl: countrySlovenia, center: [3, 46.2], scale: 12000 },
    Slovakia: { geoUrl: countrySlovakia, center: [8, 48.5], scale: 8000 },
    Poland: { geoUrl: countryPoland, center: [9, 52], scale: 3000 },
    Portugal: { geoUrl: countryPortugal, center: [-20, 39.5], scale: 4500 },
    Romania: { geoUrl: countryRomania, center: [13, 46], scale: 5000 },
    'Republic of Korea': { geoUrl: countrySouthKorea, center: [115, 36], scale: 4200 },
    Spain: { geoUrl: countrySpain, center: [-12, 40], scale: 2700 },
    Turkey: { geoUrl: countryTurkey, center: [24, 39], scale: 2500 },
    Ukraine: { geoUrl: countryUkraine, center: [19, 48.7], scale: 2600 },
    'United Kingdom': { geoUrl: countryUnitedKingdom, center: [-14, 55], scale: 1800 },
    'United States': { geoUrl: countryUnitedStates, center: [-110, 37], scale: 800 },
    'Virgin Islands (U.S.)': { geoUrl: countryUnitedStatesVirginIslands, center: [-76.8, 18], scale: 25000 },
  },
  region: {
    // United States
    Arizona: { center: [-124, 34.3], scale: 4500 },
    Arkansas: { center: [-104.5, 34.8], scale: 7000 },
    California: { center: [-132, 37.5], scale: 2500 },
    Colorado: { center: [-117.6, 39], scale: 5500 },
    Connecticut: { center: [-84.8, 41.5], scale: 20000 },
    'District of Columbia': { center: [-90, 39] },
    Georgia: { center: [-96, 32.7], scale: 5800 },
    Illinois: { center: [-101, 39.7], scale: 4200 },
    Indiana: { center: [-98.3, 39.8], scale: 6000 },
    Louisiana: { center: [-104, 31], scale: 6500 },
    Minnesota: { center: [-106.5, 46.5], scale: 3500 },
    Mississippi: { center: [-103, 33], scale: 2800 },
    Montana: { center: [-123, 47], scale: 2800 },
    'New Mexico': { center: [-119, 34], scale: 2800 },
    'North Dakota': { center: [-113, 47], scale: 2800 },
    Oklahoma: { center: [-110.8, 35.4], scale: 5500 },
    Pennsylvania: { center: [-89.7, 40.9], scale: 7200 },
    Tennessee: { center: [-98, 36], scale: 5500 },
    Virginia: { center: [-91.5, 38], scale: 5500 },
    Delaware: { center: [-89, 39], scale: 2800 },
    'West Virginia': { center: [-92.5, 39], scale: 6500 },
    Wisconsin: { center: [-103, 44.8], scale: 5000 },
    Wyoming: { center: [-121, 43], scale: 2800 },
    Alabama: { center: [-99, 32.7], scale: 5300 },
    Florida: { center: [-96, 28], scale: 4400 },
    Idaho: { center: [-128, 44], scale: 2800 },
    Kansas: { center: [-110.5, 38.5], scale: 6000 },
    Maryland: { center: [-89.3, 38.8], scale: 10000 },
    'New Jersey': { center: [-86.7, 40.1], scale: 9500 },
    'North Carolina': { center: [-92, 35.3], scale: 5800 },
    'South Carolina': { center: [-93, 33.5], scale: 7200 },
    Washington: { center: [-133, 47.3], scale: 5500 },
    Vermont: { center: [-84.5, 43.9], scale: 9200 },
    Utah: { center: [-124, 39.5], scale: 4500 },
    Iowa: { center: [-107, 42], scale: 2800 },
    Kentucky: { center: [-98, 37.7], scale: 6000 },
    Maine: { center: [-82, 45], scale: 2800 },
    Massachusetts: { center: [-85, 42], scale: 2800 },
    Michigan: { center: [-98, 45], scale: 3500 },
    Missouri: { center: [-104.5, 38.4], scale: 5500 },
    Nebraska: { center: [-113, 42], scale: 2800 },
    Nevada: { center: [-129, 38.8], scale: 3200 },
    'New Hampshire': { center: [-83.7, 44], scale: 8300 },
    'New York': { center: [-88, 42.7], scale: 5000 },
    Ohio: { center: [-95, 40.2], scale: 6500 },
    Oregon: { center: [-134, 44], scale: 2800 },
    'Rhode Island': { center: [-85, 42], scale: 2800 },
    'South Dakota': { center: [-113, 44], scale: 2800 },
    Texas: { center: [-112, 31.5], scale: 2500 },
    Alaska: { center: [-125, 27], scale: 2800 },
    Hawaii: { center: [-116, 25], scale: 2800 },
    // Canada
    Manitoba: { center: [-105, 55], scale: 1000 },
    Saskatchewan: { center: [-117, 55], scale: 1500 },
    Alberta: { center: [-127, 55], scale: 1600 },
    'British Columbia': { center: [-136, 54.5], scale: 1500 },
    Nunavut: { center: [-95, 75], scale: 300 },
    'Northwest Territories': { center: [-127, 70], scale: 500 },
    Yukon: { center: [-144, 64], scale: 1000 },
    Ontario: { center: [-94, 50], scale: 1400 },
    Quebec: { center: [-80, 54], scale: 1000 },
    'New Brunswick': { center: [-78, 47], scale: 3500 },
    'Nova Scotia': { center: [-75, 45.3], scale: 5500 },
    'Newfoundland and Labrador': { center: [-69, 53], scale: 1000 },
    'Prince Edward Island': { center: [-71, 46], scale: 1000 },
  },
};

/*
 -> not bad links to topoJson repo
  'https://github.com/deldersveld/topojson/tree/master/countries'
  'https://github.com/samateja/D3topoJson'

 -> easy way to get centroid for geounit
  components/SimpleMaps/SimpleMaps.js
  <Geographies geography={geoUrl}>
    {({ geographies, projection, path }) =>
      geographies.map(
        (geo) => {
          const [x, y] = projection.invert(path.centroid(geo));
          console.log(`${geo.properties.name}: { center: [${x.toFixed(0) - 8},${y.toFixed(0)}]}`);
          return <Geography ... />
          ...
  </Geographies>
*/
